import { render } from "./ThemeSwitch.vue?vue&type=template&id=1082427e&scoped=true"
import script from "./ThemeSwitch.vue?vue&type=script&lang=js"
export * from "./ThemeSwitch.vue?vue&type=script&lang=js"

import "./ThemeSwitch.vue?vue&type=style&index=0&id=1082427e&scoped=true&lang=css"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1082427e"]])

export default __exports__